import { Link, Navigate, useNavigate, useLocation } from "react-router-dom"
import { Button } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import { Dropdown } from "react-bootstrap"
import { useEffect, useState } from "react"
import { useAppDispatch, useAppSelector } from "../../redux/store"
import { setLanguage } from "../../redux/slices/auth/authSlice"
import HeaderBurger from "./HeaderBurger"
import HeaderControls from "./HeaderControls"
import OverlayBurger from "./overlayBurger"
import { MdLogout } from "react-icons/md"
import { FaWhatsapp } from "react-icons/fa"
import { CiAt } from "react-icons/ci"
import { TbWorldWww } from "react-icons/tb"
import { IoChevronDownSharp } from "react-icons/io5"
import api from "@/api/api"
import { logoutUser } from "../../redux/slices/auth/authSlice"
import { getBalance } from "@/redux/slices/balance/balanceSlice"
import { IoMdAdd } from "react-icons/io"
import { Tooltip } from "react-bootstrap"
import OverlayTrigger from "react-bootstrap/OverlayTrigger"
import { IoMdSettings } from "react-icons/io"

// getBalance
import "./Header.scss"

const Header = () => {
  const { t, i18n } = useTranslation()
  const location = useLocation()
  const navigate = useNavigate()

  const [lang, setLang] = useState(t("header.language2"))
  const renderTooltip = (props: any) => (
    <Tooltip id="button-tooltip" {...props}>
      Add Item
    </Tooltip>
  )

  const [balanceN, setBalance] = useState<number | null>(null)
  const [loading, setLoading] = useState<boolean>(false)
  const [error, setError] = useState<string | null>(null)

  const dispatch = useAppDispatch()
  const navigator = useNavigate()
  const { balance } = useAppSelector((state) => state.balance)

  const { isAuth, first_name, loginType } = useAppSelector(
    (state) => state.auth,
  )
  const [isOpenMenu, setIsOpenMenu] = useState(false)

  const changeLanguage = (language: string) => {
    let html = document.querySelector("html") || null
    i18n.changeLanguage(language)

    switch (language) {
      case "ar":
        html?.setAttribute("dir", "rtl")
        break
      default:
        html?.setAttribute("dir", "ltl")
        break
    }

    dispatch(setLanguage(language))
    setLang(language)
  }

  useEffect(() => {
    dispatch(getBalance()).then((data) => {})
  }, [isAuth])
  return (
    <>
      <OverlayBurger isOpenMenu={isOpenMenu} setIsOpenMenu={setIsOpenMenu} />

      <header className="header py-sm-4 py-3">
        <div className="container header-container">
          <div className="header-inner">
            <div className="logo">
              <Link to="/"></Link>

              {/* {location?.pathname == "/welcome" && ( */}
              {/* <img
                src="https://s3-alpha-sig.figma.com/img/66e2/9ee3/20a7843751f99c48bae1aef30343df33?Expires=1733097600&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=aq3fc9Yd~dGsB9QaROdnClh6cUXgSNaL1NO3DCIMnhA5l72NYoHjmbwynQbwM1Xb4gOQ1M9i-v~gI7iZE462OvrOlLJc7MO4wAw0N63usIdbQ8znModMCydSfxVvvOk1eE9LSSaZskt2ZCuehdWZSjfLxsKFwmtA6iJmXeT6hORyW1SzNthfgu9Kv9NuKzjouTbOh6uyko5wRM7PnDbKZMlFoJg~iGiOznYKyTSgSjzRJYDfoU3~caO0wM7lltm2VOnbNwSaBUi9pDbwzRsoWywo8o1SlBRPjgUusJKXWVjjlq5R0MumWuhKAkoae17n0NCKsZHlgq3F1H0Mzu2V5w__"
                alt="logo"
                style={{ width: "60px", height: "60px", cursor: "pointer" }}
              /> */}

              <img
                src="/images/invitesmart.jpg"
                style={{ width: "60px", height: "60px", cursor: "pointer" }}
              />
              {/* )}{" "} */}
            </div>

            <div className="header-inner__right me-3">
              {/* <div className="m-0 p-0">
                {isAuth && (
                  <HeaderControls balance={balance} first_name={first_name} />
                )}
              </div> */}

              {/* {isAuth && lang == "en" && (
                <>
                  {
                    <div
                      className=" d-flex flex-column ps-4 pe-4 pt-1 pb-1  me-0 me-md-5"
                      style={{
                        borderRadius: "50px",
                        backgroundColor: "#245192",
                        color: "white",
                        height: "40px",
                        // marginRight: "20px",
                      }}
                    >
                      <h6
                        className="mb-0"
                        style={{ fontSize: "13px", borderRadius: "25%" }}
                      >
                        Balance
                      </h6>
                      <span
                        className="ms-2"
                        style={{ fontSize: "12px", color: "#C1C7E4" }}
                      >
                        {balanceN ? balanceN : 0}.00
                      </span>
                    </div>
                  }
                </>
              )} */}
              {!isAuth && location?.pathname !== "/welcome" && (
                <Dropdown className="dropdown-block me-2">
                  <Dropdown.Toggle className="dropdown-block-text border-0 bg-transparent">
                    {t("header.nav.contactUs")}{" "}
                    <div>
                      {" "}
                      <IoChevronDownSharp />{" "}
                    </div>
                  </Dropdown.Toggle>

                  <Dropdown.Menu className="">
                    <Dropdown.Item className="d-flex flex-column  justify-content-center align-items-start gap-2">
                      <Link
                        to="/#"
                        className="header-nav__link d-flex flex-row align-items-center gap-2 mt-2 text-decoration-none"
                      >
                        {/* <span className="header-nav__text"> */}{" "}
                        <FaWhatsapp
                          style={{
                            color: "green",
                            fontSize: "20px",
                            marginTop: "2x",
                          }}
                        />{" "}
                        <h5
                          className="d-flex fw-normal"
                          style={{ fontSize: "1rem" }}
                        >
                          +966 505 252 278 757
                        </h5>
                        {/* </span> */}
                      </Link>
                    </Dropdown.Item>
                    <Dropdown.Item className="d-flex flex-column  justify-content-center align-items-start gap-2">
                      <Link
                        to="/#"
                        className="header-nav__link d-flex flex-row align-items-center gap-2 mt-2 text-decoration-none"
                      >
                        {/* <span className="header-nav__text"> */}{" "}
                        <CiAt
                          style={{
                            color: "#20529B",
                            fontSize: "20px",
                            marginTop: "2x",
                          }}
                        />{" "}
                        <h5
                          className="d-flex fw-normal"
                          style={{ fontSize: "1rem", textTransform: "none" }}
                        >
                          invitesmartapp@gmail.com
                        </h5>
                        {/* </span> */}
                      </Link>
                    </Dropdown.Item>
                    <Dropdown.Item
                      className="d-flex flex-column  justify-content-center align-items-start gap-2"
                      onClick={() =>
                        window.open("https://www.invitesmartapp.com/", "_blank")
                      }
                    >
                      <Link
                        to="https://www.invitesmartapp.com/"
                        target="_blank"
                        className="header-nav__link d-flex flex-row align-items-center gap-2 mt-2 text-decoration-none"
                      >
                        {/* <span className="header-nav__text"> */}{" "}
                        <TbWorldWww
                          style={{
                            color: "#20529B",
                            fontSize: "20px",
                            marginTop: "2x",
                          }}
                        />{" "}
                        <h5
                          className="d-flex fw-normal"
                          style={{ fontSize: "1rem", textTransform: "none" }}
                        >
                          www.invitesmartapp.com
                        </h5>
                        {/* </span> */}
                      </Link>
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              )}
            </div>
            <div className="d-flex gap-0 gap-md-5 ">
              <div className="d-flex align-items-center justify-content-center gap-3">
                {/* <div
                  onClick={() => navigate("/purchase")}
                  className="mt-1 d-none d-lg-flex  flex-row ps-3 pe-3 pt-2 pb-2 me-0 me-md-0"
                  style={{
                    borderRadius: "10px",
                    backgroundColor: "#245192",
                    color: "white",
                    height: "43px",
                    cursor: "pointer",
                    border: "none",
                    display: "flex",
                    alignItems: "center", 
                    justifyContent: "center",
                  }}
                >
                  <IoMdAdd style={{ fontSize: "20px", marginRight: "10px" }} />{" "}
                  <h5 className="d-flex " style={{ fontSize: "13px" }}>
                    {" "}
                    {t("header.nav.topUp")}
                  </h5>
                </div> */}
                <div className="d-flex">
                  {isAuth && (
                    <div className="d-flex gap-2">
                      <Button
                        onClick={() => navigate("/purchase")}
                        className="mt-1 d-flex flex-row ps-3 pe-3 pt-2 pb-2  me-0 me-md-0"
                        style={{
                          borderRadius: "10px",
                          backgroundColor: "#245192",
                          color: "white",
                          height: "43px",
                          // width: "100px",
                          cursor: "pointer",
                          border: "none",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <h5
                          className="m-0 p-0 mb-0 fw-normal"
                          style={{ fontSize: "13px", borderRadius: "25%" }}
                        >
                          {t("header.nav.balance")} :
                        </h5>
                        <h5
                          className="ms-0 p-0 m-0 ms-1  "
                          style={{
                            fontSize: "15px",
                            color: "#ffffff",
                            fontWeight: 900,
                          }}
                        >
                          {balance ? balance : 0}.00
                        </h5>
                      </Button>
                    </div>
                  )}
                </div>

                {/* 
                <OverlayTrigger
                  placement="bottom"
                  overlay={
                    <Tooltip id={`tooltip-bottom`}>
                      {" "}
                      {t("header.nav.topUpBalance")}{" "}
                    </Tooltip>
                  }
                >
                  <div className="d-flex align-items-center">
                    <IoMdAdd
                      style={{
                        fontSize: "20px",
                        marginRight: "8px",
                        cursor: "pointer",
                      }}
                    />
                  </div>
                </OverlayTrigger> */}
              </div>
              <Dropdown className="dropdown-block  ">
                <Dropdown.Toggle className="dropdown-block-text border-0 bg-transparent d-flex align-items-center">
                  {lang === "ar"
                    ? t("header.language1")
                    : t("header.language2")}
                  <div>
                    {" "}
                    <IoChevronDownSharp />{" "}
                  </div>
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <Dropdown.Item
                    active={lang.toLowerCase() === "ar"}
                    onClick={() => changeLanguage("ar")}
                  >
                    {t("header.language1")}
                  </Dropdown.Item>
                  <Dropdown.Item
                    active={lang.toLowerCase() === "en"}
                    onClick={() => changeLanguage("en")}
                  >
                    {t("header.language2")}
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>

              <div className="m-0 p-0 d-none d-lg-block">
                {/* {isAuth && (
                  <HeaderControls balance={balance} first_name={first_name} />
                )} */}
                {isAuth && (
                  <Dropdown className="dropdown-block dropdown-profile">
                    <Dropdown.Toggle
                      className="dropdown-block-text border-0 bg-transparent"
                      style={{ fontFamily: "Inter" }}
                    >
                      {/* {first_name} */}
                      <div>
                        {" "}
                        <IoMdSettings style={{ fontSize: "20px" }} />{" "}
                      </div>
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      <Dropdown.Item
                        onClick={() => {
                          navigator("/profile")
                        }}
                      >
                        {t("header.nav.profile")}
                      </Dropdown.Item>

                      <Dropdown.Item
                        onClick={() => {
                          dispatch(logoutUser())
                        }}
                      >
                        {t("buttons.exit")}
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                )}
              </div>
            </div>
            {isAuth && (
              <HeaderBurger
                isOpenMenu={isOpenMenu}
                setIsOpenMenu={setIsOpenMenu}
              />
            )}
          </div>
        </div>
      </header>
    </>
  )
}

export default Header
